<template>
<div class="edit-contact">

    <vue-headful
        title="TZ Design Box - Edit Contact"
        description="TZ Design Box"
    />

    <div class="container">
        <div class="columns">
        <div class="column is-2 menu-vert">
            <MenuVert :currentactive="'overview-contacts'" />
        </div>
        <div class="column is-10" style="margin-top:25px;">
            <Breadcrumbs/>
            <hr>
            <div class="content">
            <h2>{{ $t("contact-edit") }} </h2>
            <p>{{ $t("contact-edit-details") }} </p>
            <form @submit.prevent="validateBeforeSubmit">
                <b-field grouped>
                    <b-field :label="$t('firstname')" expanded
                        :type="{'is-danger': errors.has('first_name')}"
                        :message="errors.first('first_name')">
                        <b-input v-model="getContact.first_name" name="first_name" v-validate="'required'" />
                    </b-field>
                    <b-field :label="$t('secondname')" expanded
                        :type="{'is-danger': errors.has('middle_name')}"
                        :message="errors.first('middle_name')">
                        <b-input v-model="getContact.middle_name" name="Middle Name" />
                    </b-field>
                    <b-field :label="$t('lastname')" expanded
                        :type="{'is-danger': errors.has('last_name')}"
                        :message="errors.first('last_name')">
                        <b-input v-model="getContact.last_name" name="Last Name" />
                    </b-field>
                </b-field>

                <b-field :label="$t('email')"
                    :type="{'is-danger': errors.has('email')}"
                    :message="errors.first('email')">
                    <b-input v-model="getContact.email" name="email" v-validate="'required|email'" />
                </b-field>

                <b-field :label="$t('language')" v-if="! loadContact">
                    <b-select v-model="getContact.language [0]">
                        <option
                            v-for="language in getCurrentCompany.language_choices"
                            :value="language[0]"
                            :key="language[0]">
                            {{ language[1] }}
                        </option>
                    </b-select>
                </b-field>
                <b-field :label="$t('my-company')" v-if="! loadContact">
                    <b-select v-model="getContact.company [0]">
                        <option
                            v-for="parent in getContact.parent_choices"
                            :value="parent[0]"
                            :key="parent[0].toString ()">
                            {{ parent[1] }}
                        </option>
                    </b-select>
                </b-field>
                <b-field label="" class="is-checkradio"
                    :type="{'is-danger': errors.has('dealer_admin')}"
                    :message="{'required' : errors.firstByRule('dealer_admin', 'required')}">
                    <b-checkbox v-model="getContact.dealer_admin" name="dealer_admin">
                        {{ $t("dealer-admin") }}
                    </b-checkbox>
                </b-field>

                <b-field label="" class="is-checkradio"
                    :type="{'is-danger': errors.has('opt_out')}"
                    :message="{'required' : errors.firstByRule('opt_out', 'required')}">
                    <b-checkbox v-model="getContact.opt_out" name="opt_out">
                        {{ $t("newsletter") }}
                    </b-checkbox>
                </b-field><br>

                <b-field grouped>
                  <b-button type="is-primary" :loading="saveInProgress" native-type="submit"> {{ $t("save") }}  </b-button>
                  <b-button v-if="canChangePassword"
                    type="is-info"
                    :loading="saveInProgress"
                    @click="changePassword"
                    > {{ $t("change-password") }}  </b-button>
                </b-field>
            </form>
            </div>
        </div>
        </div>
    </div>
    </div>
</template>

<script>
import axios                from "axios"
import MenuVert             from '@/components/MenuVert'
import Breadcrumbs          from '@/components/Breadcrumbs'
import { mapGetters }       from 'vuex'

export default {
    name:'EditContact',
    props: ['coid'],
    computed: {
        ...mapGetters([
            "getCurrentCompany",
            "getContact",
            "loadContact",
            "getUserToken",
            "getCompany"
            ]),
        canChangePassword () {
            return this.$store.state.user.user.groups.has ("CAN_CHANGE_PASSWORD")
        },
    },
    data: function () {
            return {
                saveInProgress: false
            }
        },
    components:{
        MenuVert,
        Breadcrumbs
    },
    methods: {
        validateBeforeSubmit () {
            var self=this
            this.$validator.validateAll().then((result) => {
                if (result) {
                    this.saveInProgress = true
                    this.$store.dispatch(
                        "saveEditContact",
                        {self:self,coid:this.coid,cid:this.getCompany})
                    .then (response => {
                        self.saveInProgress = false
                    })
                    .catch((error) =>{
                        self.saveInProgress = false
                        self.$toastr('error', error, 'Failure')
                    })
                    return
                }
            });
        },
        changePassword () {
            axios.post (
                "/vue/password/change-link/",
                { email: this.getContact.email },
                {headers: { Authorization: "Token " + this.getUserToken }}
            ).then (response => {
                if (response.data.status) {
                    this.$router.push (
                        { name: "password-reset",
                          params: {token: response.data.data.token}}
                        )
                }
            })
        },
        fetchContact() {
            this.$store.dispatch("callContactDetails",{self:this, coid:this.coid});
        }
    },
    beforeRouteUpdate (to, from, next) {
        this.fetchContact()
        next ()
    },
    mounted () {
        this.$store.dispatch("callCurrentCompany",{self:this, company:this.getCompany});
        this.fetchContact()
    }
}
</script>

<style>
.edit-contact{
    padding-bottom:50px;
}
.content{
    background-color:#fff!important;
    padding:25px;
    box-shadow: 0 1px #FFFFFF inset, 0 1px 3px rgba(34, 25, 25, 0.4);
}
</style>
